module.exports = "<div class=\"OUTBRAIN\" data-widget-id=\"<%=widgetCode%>\" data-ob-template=\"guardian\"></div>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/commercial/views/outbrain.html
// module id = 592
// module chunks = 0